"use strict";

exports.__esModule = true;
exports["default"] = isIE;

function isIE() {
  return (/msie (8|9|10)/i.test(window.navigator.userAgent)
  );
}

module.exports = exports["default"];